import image1 from "..//images//01.png";

import image3 from "..//images//03.png";
import image7 from "..//images//07.png";
import image8 from "..//images//08.png"

const projects = [
  {
    title: "Resume Website",
    category: "Work",
    image: image1,
    url: "https://www.mattgainerdevelopment.com/",
  },
    {
    title: "Rogers Bank",
    category: "Banking",
    image: image8,
    url: "https://selfserve.rogersbank.com/sign-in?locale=en",
  },
  {
    title: "Foodio Fare",
    category: "Food",
    image: image3,
    url: "https://www.foodiofare.com/",
  },

  {
    title: "Life Pure Essentials",
    category: "eCommerce",
    image: image7,
    url: "https://lifepureessentials.com/",
  },
];

const skills = [
  {
    name: "REACTJS",
    level: "95",
  },
  {
    name: "JAVASCRIPT",
    level: "90",
  },
  {
    name: "SCSS",
    level: "90",
  },
  {
    name: "CSS",
    level: "90",
  },
  {
    name: "WEBAPI",
    level: "90",
  },

  {
    name: "KNEX",
    level: "80",
  },
  {
    name: "NODEJS",
    level: "80",
  },
  {
    name: "EXPRESS",
    level: "80",
  },
  {
    name: "DOM",
    level: "90",
  },
  {
    name: "AGILE",
    level: "100",
  },
  {
    name: "JIRA",
    level: "100",
  },
  {
    name: "CONFLUENCE",
    level: "100",
  },
  {
    name: "TS2 (TSYS)",
    level: "100",
  },
  {
    name: "MYSQL",
    level: "80",
  },
  {
    name: "BUSINESS PROCESS MODELING",
    level: "100",
  },
  {
    name: "BUSINESS PROCESS MODELING",
    level: "100",
  },
  {
    name: "BUSINESS CASE MANAGEMENT",
    level: "100",
  },
  {
    name: "REQUIREMENTS GATHERING AND ANALYSIS",
    level: "100",
  },
];

export { projects, skills };
